import get from 'lodash/get';
import size from 'lodash/size';
import {getEditFieldValues, getItemId, getSetCurrentModelId, getTranslation, getTyped} from "~/stateGetter";
import {hideConfirmNavigationDialog, showConfirmNavigationDialog} from "~/actions/ui_actions";
import isPathDiscardingData from "~/navigation/helpers/isPathDiscardingData";
import lexModelPathName from "~/navigation/helpers/lexModelPathName";
import {ROUTE_TYPES} from "~/navigation/routes";
import identify from "~/identify";
import {areValuesEqual} from "~/statePresenter";



export default function createConfirmNavigation(store, action) {
    const dispatch = store.dispatch;
    let data = action.payload,
        type = data.result.type,
        confirmed = get(action, 'payload.options.confirmed', false),
        noConfirm = get(action, 'payload.options.noConfirm', false),
        changeRootModel = get(action, 'payload.options.forceChangeRootModel', false);

    const MESSAGE = getTranslation(store.getState(), 'confirmNavigation.message');

    const confirmItemNavigation = (modelId) => {
        let state  = store.getState(),
            messages = [];

        // check if values of the item have been updated
        let values = getEditFieldValues(state, modelId),
            startValues = getTyped(state, modelId, identify.EDITFIELD, 'startValues');

        if(!areValuesEqual(values, startValues)) {
            messages.push(MESSAGE);
        }

        return messages;
    };

    const confirmModelNavigation = (modelId) => {
        let state  = store.getState(),
            itemId = getItemId(state, modelId),
            messages = [];

        if(itemId) {
            messages = [...messages, ...confirmItemNavigation(modelId, itemId)];
        }

        return messages;
    };

    const confirmModelPathNavigation = () => {
        let messages = [],
            state  = store.getState(),
            currentPath = action.payload.pathname,
            lexedPath = lexModelPathName(currentPath);

        if(isPathDiscardingData(state, lexedPath, changeRootModel, noConfirm)) {
            messages.push(MESSAGE);
        }

        return messages;
    };

    const confirmNavigation = () => {
        if(noConfirm) { return true; }

        if(confirmed) {
            dispatch(hideConfirmNavigationDialog());
            return true;
        }

        // check if item values have changed
        let state  = store.getState(),
            messages = [];

        switch(type) {
            case ROUTE_TYPES.ALL_MODELS:
            case ROUTE_TYPES.EDIT_ENTRY:
            case ROUTE_TYPES.SUBVIEW:
            case ROUTE_TYPES.VIEW_ENRY:
                messages = [...messages, ...confirmModelPathNavigation()];
                break;
            default:
                let modelId = getSetCurrentModelId(state);
                if(modelId) {
                    messages = [...messages, ...confirmModelNavigation(modelId)];
                }
                break;
        }
        
        if(messages.length > 0) {
            dispatch(showConfirmNavigationDialog(messages));
            return false;
        }

        return true;
    };

    return confirmNavigation;
}